module.exports = __webpack_public_path__ + "static/media/clientcare.e4bf6d2c.png";